export default "__VITE_ASSET__kvZ9JBfx__"